import React, { useMemo } from 'react'
import { SideSection, SideSectionButton, SideSectionButtonBorderOptions } from './styles'
import { useOperationDespatchContext } from '../../../../../../../../contexts/DespatchContext';
import { ArrowLeft2, ArrowRight2 } from 'iconsax-react';
import { IoMdClose } from 'react-icons/io';

export enum SidePositionOptions {
  LEFT = "left",
  RIGHT = "right",
}
interface SideViewWrapperProps {
  children: React.ReactNode;
  sidePosition: SidePositionOptions;
}

const ICON_SIZE = 16;
const ICON_COLOR = "#475467";

export const SideViewWrapper = ({children, sidePosition}: SideViewWrapperProps) => {
  const { 
    setShowLeftSideView,
    setShowRightSideView,
    showLeftSideView, 
    showRightSideView,
  } = useOperationDespatchContext();

  const sideViewVariables = useMemo(() => {
    switch (sidePosition) {
      case SidePositionOptions.LEFT:
        return {
          isOpen: showLeftSideView,
          setShowSideView: setShowLeftSideView,
          icon: <ArrowRight2 color={ICON_COLOR} size={ICON_SIZE}/>,
          border:SideSectionButtonBorderOptions.RIGHT,
        }
        
      case SidePositionOptions.RIGHT:
      default:
        return {
          isOpen: showRightSideView,
          setShowSideView: setShowRightSideView,
          icon: <ArrowLeft2 color={ICON_COLOR} size={ICON_SIZE}/>,
          border: SideSectionButtonBorderOptions.LEFT,
        }
    }
  }, [sidePosition, showLeftSideView, showRightSideView])

  const onToggleShowSideView = () => sideViewVariables.setShowSideView((prev)=> !prev)

  const renderIcon = useMemo(() => {
    if (sideViewVariables?.isOpen) return <IoMdClose color={ICON_COLOR} size={ICON_SIZE}/>
    return sideViewVariables.icon;
  }, [sideViewVariables])

  return (
    <SideSection>
        {sideViewVariables.isOpen && children}
        <SideSectionButton border={sideViewVariables.border} onClick={onToggleShowSideView}>
          {renderIcon}
        </SideSectionButton>
    </SideSection>
  )
}
